module.exports = __webpack_public_path__ + "a81ed150f8a7fc00a22a99edcc66bee5.png";


//////////////////
// WEBPACK FOOTER
// ./markup/img/pattern-2.png
// module id = 1144
// module chunks = 0